import React from 'react';
import cx from 'classnames';

const ModalWrapper = ({ children, className }) => {
  return <div className={cx('modal-content', className)}>{children}</div>;
};

export default ModalWrapper;
